import NodeAuth from "node-auth-api";

const initialState = {
  isLoggedIn: false,
  loading: false,
  querying_store: false,
  query_error: null,
  username: null,
  errors: [],
  avatar: "/img/user2-160x160.jpg",
};

if(NodeAuth.User.isLoggedIn("user")) {
  initialState.isLoggedIn = true;
  initialState.username = NodeAuth.User.getTokenPayload("user").name
}

export default function (state = initialState, action) {
  switch(action.type) {
    case USER_LOGIN:
      return {
        ...state,
        username: action.username,
        avatar: action.avatar,
        isLoggedIn: true,
        loading: false
      }

    case USER_LOGOUT:
      return {
        ...state,
        username: '',
        avatar: '',
        isLoggedIn: false,
        loading: false
      }

    case USER_LOADING:
      return {
        ...state,
        loading: true
      }

    case USER_QUERYING_STORE:
      return {
        ...state,
        querying_store: action.queryingStore,
        query_error: action.error
      }

    case USER_ERRORS:
      return {
        ...state,
        errors: action.errors,
        loading: false,
      }

    case CLEAR_USER_ERRORS:
      return {
        ...state,
        query_error: null,
        errors: []
      }

    default:
      return state;
  }
}


// Action types
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOADING = "USER_LOADING";
export const USER_QUERYING_STORE = "USER_QUERYING_STORE";
export const USER_ERRORS = "USER_ERRORS";
export const CLEAR_USER_ERRORS = "CLEAR_USER_ERRORS";